module.exports = __webpack_public_path__ + "files/import-menu-template.xlsx";